import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './style/UploadPage.css';
import { SUBSCRIPTION_LIMITS } from '../constants/subscriptionRules';
import LoaderPanel from '../components/LoaderPanel';
import LoadingLogo from '../components/LoadingLogo';
import logoBOW from '../assets/img/logobeonwall.png';
import { useNavigate } from 'react-router-dom';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import Lottie from 'lottie-react';
import donateAnimation from '../assets/animations/donate.json';
import { TbWorldWww } from "react-icons/tb";
import ShareButton from '../components/ShareButton';



const baseUrl = process.env.REACT_APP_API_URL;
const endpointuploadcom = `${baseUrl}/upload-comments`;
const endpointuploadimage = `${baseUrl}/upload-img`;
const endpointPublicEvent = `${baseUrl}/public-events`;


function UploadPage() {
  const navigate = useNavigate();
  const { eventId } = useParams();
  const [commentaire, setCommentaire] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [eventData, setEventData] = useState(null);
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(null); // 'loading', 'success', 'error'
  const [progress, setProgress] = useState(0);
  const [uploadType, setUploadType] = useState(null); // 'image' ou 'comment'


  

  const maxChars = 60;


const isLimitReached = (data, type) => {
  if (!data?.sub) return false;
  const limits = SUBSCRIPTION_LIMITS[data.sub];
  if (!limits) return false;
  return type === 'comment'
    ? data.numbercomments >= limits.maxComments
    : data.numberpicture >= limits.maxPictures;
};



  const parseResponse = (data) => {
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return {};
      }
    }
    return data;
  };

  useEffect(() => {
    const fetchEventInfo = async () => {
      try {
        const res = await axios.get(`${endpointPublicEvent}/${eventId}`);
        console.log("Événement récupéré :", res.data);
        setEventData({ ...res.data }); // force un rerender

      } catch (error) {
        console.error("Erreur lors de la récupération de l'événement :", error);
      }
    };
  
    fetchEventInfo();
  }, [eventId]);
  

  const compressImage = (file, maxSize = 2000, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          const readerCompressed = new FileReader();
          readerCompressed.onloadend = () => {
            const base64Data = readerCompressed.result.split(',')[1];
            resolve(base64Data);
          };
          readerCompressed.readAsDataURL(blob);
        },
        'image/jpeg',
        quality
      );
    };

    img.onerror = reject;
  });
};


const handleSubmitComment = async (e) => {
  e.preventDefault();
  setSuccess('');
  setError('');
  setIsLoading(true);

  if (!commentaire.trim()) {
    setError("Merci de remplir un commentaire.");
    setIsLoading(false);
    return;
  }

  try {
    const res = await axios.get(`${endpointPublicEvent}/${eventId}`);
    const freshData = res.data;
    // Conditon pour vérifier si l'événement est terminé
    const seuil = freshData.seuildepassement; 
    if (seuil) {
      const [day, month, year] = seuil.split('/');
      const seuilDate = new Date(`${year}-${month}-${day}T00:00:00`); 
      seuilDate.setDate(seuilDate.getDate() + 2); // Ajout de 2 jours

      // 2. Comparer avec la date du jour
      const now = new Date();
      now.setHours(0,0,0,0); // On ignore l'heure pour la comparaison

      if (now > seuilDate) {
        setError("⚠️ Vous avez atteint la date limite de l'événement.");
        setIsLoading(false);
        return;
      }
    }
    // Condition pour vérifier la limite de commentaires
    if (isLimitReached(freshData, 'comment')) {
      setError(`⚠️ Limite de commentaires atteinte pour cet evenement).`);
      setIsLoading(false);
      return;
    }
    setUploadStatus('loading');
    let i = 0;
    const interval = setInterval(() => {
      i += 5;
      setProgress(i);
      if (i >= 100) clearInterval(interval);
    }, 20);

   

  const response = await axios.post(
    endpointuploadcom,
    JSON.stringify({
      eventId,
      commentaire: commentaire.trim(),
      sub: freshData.sub
    }),
    { headers: { 'Content-Type': 'application/json' } }
  );

  let parsed = {};
  const body = response?.data?.body;
  if (body) {
    try {
      parsed = JSON.parse(body);
    } catch (e) {
      console.error("[UploadPage] Erreur de parsing JSON : ", e, "body reçu : ", body);
      throw new Error("Erreur lors du parsing JSON du retour.");
    }
  } else if (typeof response.data === "object" && response.data !== null) {
    parsed = response.data;
  } else {
    console.warn("[UploadPage] Réponse backend inattendue :", response.data);
    throw new Error("Donnée de réponse vide ou mal formatée.");
  }
  console.log("[UploadPage] Réponse backend :", parsed);

  if (parsed.statusCode >= 400) throw new Error(parsed.message || "Erreur inconnue");

  setSuccess(parsed.message || "Commentaire envoyé avec succès !");
  setCommentaire('');
  setUploadType('comment');
  setUploadStatus('success');
  setTimeout(() => setUploadStatus(null), 7000);

  } catch (err) {
    let customMsg = "";
    if (err.response && err.response.data) {
      let res = err.response.data;
      // Peut-être stringifié
      if (typeof res === "string") {
        try { res = JSON.parse(res); } catch { /* ignore */ }
      }
      // Peut-être encapsulé dans .body
      if (res.body) {
        try { res = JSON.parse(res.body); } catch { /* ignore */ }
      }
      if (res.message) customMsg = res.message;
    }
    setError(customMsg || err.message || "Erreur lors de l'envoi du commentaire.");
    setUploadStatus('error');
    setUploadType('comment'); // bien préciser le type ici
    setTimeout(() => setUploadStatus(null), 7000);
  } finally {
    setIsLoading(false);
  }

};


  const handleSubmitImage = async (e) => {
  e.preventDefault();
  setSuccess('');
  setError('');
  setPreviewUrl(null);
   setIsLoading(true);

  if (!imageFile) {
    setError("Merci de sélectionner une image.");
    setIsLoading(false);
    return;
  }

  try {


    const ress = await axios.get(`${endpointPublicEvent}/${eventId}`);
    const freshData = ress.data;
    console.log("Données de l'événement récupérées :", freshData);

    // 1. Récupération et parsing de la date seuildepassement
    const seuil = freshData.seuildepassement; // ex: '05/06/2025'
    if (seuil) {
      const [day, month, year] = seuil.split('/');
      const seuilDate = new Date(`${year}-${month}-${day}T00:00:00`); // Création de la date JS
      seuilDate.setDate(seuilDate.getDate() + 2); // Ajout de 2 jours

      // 2. Comparer avec la date du jour
      const now = new Date();
      now.setHours(0,0,0,0); // On ignore l'heure pour la comparaison

      if (now > seuilDate) {
        setError("⚠️ Vous avez atteint la date limite de l'événement.");
        setIsLoading(false);
        return;
      }
    }


    if (isLimitReached(freshData, 'image')) {
      setError(`⚠️ Limite d’images atteinte pour cet evenement).`);
      setIsLoading(false);
      return;
    }

    setUploadStatus('loading');
    let i = 0;
    const interval = setInterval(() => {
      i += 5;
      setProgress(i);
      if (i >= 100) clearInterval(interval);
    }, 20);


    const base64Data = await compressImage(imageFile, 3000, 0.8);

    const payload = {
      items: [
        {
          name: imageFile.name,
          data: base64Data,
          eventId: eventId,
          sub: freshData.sub
        }
      ]
    };

    const response = await axios.post(
      endpointuploadimage,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );

    const res = parseResponse(response.data);
    if (res.statusCode >= 400) {
      throw new Error(res.message || "Erreur lors de l'upload.");
    }

    setSuccess("Image envoyée avec succès !");
    setUploadType('image');
    setUploadStatus('success');
    setTimeout(() => setUploadStatus(null), 7000);
    setImageFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Réinitialise l'input fichier
    }
    } catch (err) {
      let customMsg = "";
      // axios met la réponse dans err.response.data
      if (err.response && err.response.data) {
        let res = err.response.data;
        // Peut-être stringifié
        if (typeof res === "string") {
          try { res = JSON.parse(res); } catch { /* ignore */ }
        }
        // Peut-être encapsulé dans .body
        if (res.body) {
          try { res = JSON.parse(res.body); } catch { /* ignore */ }
        }
        if (res.message) customMsg = res.message;
      }
      setError(customMsg || err.message || "Erreur lors de l'envoi de l'image.");
      setUploadStatus('error');
      setUploadType('image'); // pour différencier les cas si besoin dans LoaderPanel
      setTimeout(() => setUploadStatus(null), 7000);
    } finally {
      setIsLoading(false);
    }

  };


  if (!eventData) return <LoadingLogo />;

return (
  <>
  <div
      style={{
         height: '8vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'black', // ou autre selon ton design
      marginTop: '5vh',
      }}
    >
      <img
        src={logoBOW}
        alt="BeOnWall Logo"
        style={{
          maxWidth: '200px',
          width: '80%',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/')}
      />
  </div>
   <footer className="upload-footer">
      <div className="upload-socials">
        <a
          href="https://www.beonwall.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="upload-social-link"
        >
          <TbWorldWww aria-hidden="true" />
        </a>
        <a
          href="https://www.instagram.com/be.on.wall/"
          target="_blank"
          rel="noopener noreferrer"
          className="upload-social-link"
        >
          <FaInstagram aria-hidden="true" />
        </a>
        <a
          href="https://www.tiktok.com/@beonwall?lang=fr"
          target="_blank"
          rel="noopener noreferrer"
          className="upload-social-link"
        >
          <FaTiktok aria-hidden="true" />
        </a>
      </div>
    </footer>      
  <div className="upload-page">
    <div className="upload-page-container">
      <div className="upload-header">
        <h2 className="upload-title-h2">
          {eventData?.eventName || "Événement"}
        </h2>

        {/* Le composant existant, inchangé */}
        <ShareButton
          eventId={eventId}
          eventName={eventData?.eventName}
          shareUrl={`${window.location.origin}/${eventId}/upload`}
        />
      </div>



      {eventData.eventType === 'photopredefini' ? (
        <div className="info-message">
          <p>⚠️ Cet événement n'autorise pas l’envoi de contenu en direct.</p>
          <p>Les photos sont prédéfinies et ne peuvent pas être modifiées.</p>
        </div>
      ) : (
        <>
          {/* Formulaire texte si applicable */}
          {(eventData.eventType === 'livetext' || eventData.eventType === 'livephototext') && (
            <>
              <h3 className="upload-title">Envoie un message à l'événement</h3>
              <form onSubmit={handleSubmitComment}>
                <textarea
                  placeholder="Ton message ici..."
                  value={commentaire}
                  maxLength={maxChars}
                  onChange={(e) => setCommentaire(e.target.value)}
                  rows={4}
                />
                <p className="char-count">{commentaire.length}/{maxChars} caractères</p>
                <button type="submit" disabled={isLoading}>
                  {isLoading ? 'Envoi en cours...' : 'Envoyer'}
                </button>
              </form>
            </>
          )}

          {/* Séparateur si les deux sont présents */}
          {eventData.eventType === 'livephototext' && (
            <div className="separator">
              <div></div>
              <span>Ou</span>
              <div></div>
            </div>
          )}

          {/* Formulaire image si applicable */}
          {(eventData.eventType === 'livephoto' || eventData.eventType === 'livephototext') && (
            <>
              <h3 className="upload-title">Ajoute une image à l'événement</h3>
              <form onSubmit={handleSubmitImage}>
                <div className="custom-file-upload">
                  <label htmlFor="fileUpload">📷 Choisir une image</label>
                  <input
                    id="fileUpload"
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={(e) => setImageFile(e.target.files[0])}
                  />
                  {imageFile && <p className="file-name">{imageFile.name}</p>}
                </div>

                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Envoi de l'image..." : "Envoyer l'image"}
                </button>

              </form>

              {previewUrl && (
                <div className="preview-container">
                  <p>Aperçu de l’image envoyée :</p>
                  <img src={previewUrl} alt="uploaded" />
                </div>
              )}
            </>
          )}
        </>
      )}
      {uploadStatus && (
        <LoaderPanel
          progress={progress}
          status={uploadStatus}
          type={uploadType}
          errorMsg={error}  // ← ajoute ce prop
          onClose={() => {
            setUploadStatus(null);
            setProgress(0);
            setError(''); // clean l’erreur après fermeture
          }}
        />

      )}

      {success && <p className="success-message">{success}</p>}
      {error && error !== "Request failed with status code 400" && (
        <p className="error-message">{error}</p>
      )}

      {eventData.cagnotte_enable === "true" && eventData.cagnotte_url && (
        <div className="cagnotte-banner">
          <p className="cagnotte-text">💛 Soutenez cet événement en faisant un don ! 💛 <br /> Cliquez sur Donate !</p>
          
          
          <a
            href={eventData.cagnotte_url}
            target="_blank"
            rel="noopener noreferrer"
            className="cagnotte-lottie-link"
          >
            <Lottie
              animationData={donateAnimation}
              loop
              style={{ height: 200, width: 200 }}
            />
          </a>
        </div>
      )}




    </div>
  </div>
  
  </>
);

  
}  

export default UploadPage;
